import React from 'react';
import useSearchParams from './hooks.useSearchParams';
import useIntl from '../../hooks/useIntl';

import {
  Banner,
  Grid,
} from '@fortress-technology-solutions/fortress-component-library/Molecules';
import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';

import messages from './messages';

const MixedPropertyAffordableTransferBanner = ({ isMixedProperty }) => {
  const { isTransfer } = useSearchParams();

  const intl = useIntl();

  const showMixedPropertyBanner = isMixedProperty && isTransfer;

  return (
    <Grid container fluid spacing={1} marginTop={1} marginBottom={2}>
      {showMixedPropertyBanner && (
        <Grid item xs={12}>
          <Banner
            color={'lightGrey'}
            TypographyProps={{
              noWrap: false,
            }}
            hasBorder={false}
            text={intl?.formatMessage(
              messages.floorplanTypeTransferRestrictionBanner,
            )}
            icon={<AlertInfoIcon />}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default MixedPropertyAffordableTransferBanner;
